module.exports = __webpack_public_path__ + "img/footer-bg.139ff94e.png";